// extracted by mini-css-extract-plugin
export default {"wrapper":"OrganizationLandscapesTemplate_wrapper__KbaEH","buttonBorder":"OrganizationLandscapesTemplate_buttonBorder__4W8zV"};